"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7279],{

/***/ 57279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/components/ConditionalRender/index.tsx + 2 modules
var ConditionalRender = __webpack_require__(93314);
// EXTERNAL MODULE: ./src/components/AppBanner/utils.ts
var utils = __webpack_require__(41167);
// EXTERNAL MODULE: ./src/components/AppBanner/useAppBanner.ts
var useAppBanner = __webpack_require__(7598);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils_utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(39997);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ChevronRight.js
var ChevronRight = __webpack_require__(32680);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/components/AppBanner/AppBanner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background-color: #002f6b;\n  color: ",
        ";\n  padding: 10px;\n  @media (min-width: 400px) {\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var COOKIE_MAX_AGE = 2592000 // 30 Days
;
var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2fddb120-0"
})(_templateObject(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-2fddb120-1"
})(_templateObject1(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var appIconUrl = "https://s1.pclncdn.com/design-assets/brand-assets/app-icon.svg";
function AppBanner(param) {
    var isAndroid = param.isAndroid, titleText = param.titleText, contentText = param.contentText, pageId = param.pageId, referral = param.referral, clientGUID = param.clientGUID;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setBannerVisible = ref[1];
    var closeAppBanner = function() {
        setBannerVisible(false);
        document.cookie = "hideAppBanner=true; domain=.priceline.com; path=/; max-age=".concat(COOKIE_MAX_AGE, ";");
    };
    var appBannerDefault = (0,useSeti/* default */.Z)("MBL_HP_APP_BANNER_REDESIGN", false) === "DEFAULT";
    return isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    size: 16,
                    id: "closeBannerBtn",
                    "data-ga-category": "PCLN_HOME",
                    "data-ga-action": "App_Banner",
                    "data-ga-label": "dismiss",
                    title: "dismiss app banner",
                    onClick: closeAppBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                color: "text.lightest",
                href: (0,utils/* getLink */.Rg)(isAndroid, referral, clientGUID, "".concat(appBannerDefault ? "".concat(pageId, "_v3") : "".concat(pageId, "_v6"))),
                "data-testid": "DASH_MWEB_TAB_GET_APP",
                "data-ga-category": "PCLN_HOME",
                "data-ga-action": "App_Banner",
                "data-ga-label": "click to launch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "flex-start",
                        px: 12,
                        py: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: appIconUrl,
                            alt: "Priceline Icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontWeight: "bold",
                                fontSize: 15,
                                lineHeight: "19px",
                                mb: 1,
                                children: titleText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 13,
                                lineHeight: "12px",
                                children: contentText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        ml: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                            title: "click to launch app",
                            color: "text.lightest",
                            size: 20
                        })
                    })
                ]
            })
        ]
    }) : null;
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
;// CONCATENATED MODULE: ./src/components/AppBanner/AppBannerExperiment/AppBannerExperiment.tsx

function AppBannerExperiment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 8px;\n  @media (min-width: 400px) {\n    padding-right: 24px;\n  }\n"
    ]);
    AppBannerExperiment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AppBannerExperiment_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    AppBannerExperiment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var AppBannerExperiment_COOKIE_MAX_AGE = 2592000 // 30 Days
;
var AppBannerExperiment_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c4e8924e-0"
})(AppBannerExperiment_templateObject(), (0,utils_utils/* getPaletteColor */.ow)("background.base"), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var AppBannerExperiment_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-c4e8924e-1"
})(AppBannerExperiment_templateObject1(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var AppBannerExperiment_appIconUrl = "https://s1.pclncdn.com/design-assets/brand-assets/app-icon.svg";
function AppBannerExperiment(param) {
    var isAndroid = param.isAndroid, titleText = param.titleText, contentText = param.contentText, pageId = param.pageId, referral = param.referral, clientGUID = param.clientGUID;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setBannerVisible = ref[1];
    var closeAppBanner = function() {
        setBannerVisible(false);
        document.cookie = "hideAppBanner=true; domain=.priceline.com; path=/; max-age=".concat(AppBannerExperiment_COOKIE_MAX_AGE, ";");
    };
    var appBannerNoDismiss = (0,useSeti/* default */.Z)("MBL_HP_APP_BANNER_REDESIGN", false) === "NO_DISMISS";
    return isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBannerExperiment_Container, {
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        m: 1,
        borderRadius: "lg",
        children: [
            !appBannerNoDismiss && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                mr: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    style: {
                        color: "#0068ef"
                    },
                    size: 24,
                    id: "closeBannerBtn",
                    "data-ga-category": "PCLN_HOME",
                    "data-ga-action": "App_Banner",
                    "data-ga-label": "dismiss",
                    title: "dismiss app banner",
                    onClick: closeAppBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBannerExperiment_StyledLink, {
                color: "text.lightest",
                href: (0,utils/* getLink */.Rg)(isAndroid, referral, clientGUID, "".concat(appBannerNoDismiss ? "".concat(pageId, "_v4") : "".concat(pageId, "_v5"))),
                "data-testid": "DASH_MWEB_TAB_GET_APP",
                "data-ga-category": "PCLN_HOME",
                "data-ga-action": "App_Banner",
                "data-ga-label": "click to launch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "flex-start",
                        pr: 12,
                        py: 0,
                        width: 52,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: AppBannerExperiment_appIconUrl,
                            alt: "Priceline Icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontWeight: "bold",
                                textStyle: "captionBold",
                                color: "background.darkest",
                                children: titleText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                textStyle: "disclaimer",
                                color: "background.dark",
                                children: contentText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        ml: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            ml: "auto",
                            my: "auto",
                            pl: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                size: "small",
                                children: "Get"
                            })
                        })
                    })
                ]
            })
        ]
    }) : null;
}

;// CONCATENATED MODULE: ./src/components/AppBanner/index.tsx










var AppBannerWrapper = function(_param) {
    var content = _param.content, props = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var showAppBanner = (0,useAppBanner/* default */.Z)();
    var bootstrapData = (0,react.useContext)(BootstrapDataContext/* default */.Z);
    return showAppBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* default */.ZP, {
        experimentCode: "MBL_HP_APP_BANNER_REDESIGN",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Original */.gg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBanner, (0,_object_spread/* default */.Z)({}, (0,utils/* getPropsForAppBanner */.we)(bootstrapData), content, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBannerExperiment, (0,_object_spread/* default */.Z)({}, (0,utils/* getPropsForAppBanner */.we)(bootstrapData), content, props))
            })
        ]
    }) : null;
};
/* harmony default export */ var components_AppBanner = (AppBannerWrapper);


/***/ }),

/***/ 93314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KS": function() { return /* reexport */ Experiment; },
  "gg": function() { return /* reexport */ Original; },
  "ZP": function() { return /* reexport */ ConditionalRender; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/experimentation/dist/esm/index.js + 4 modules
var esm = __webpack_require__(80460);
// EXTERNAL MODULE: ./src/hooks/useGA4Analytics.ts + 3 modules
var useGA4Analytics = __webpack_require__(8176);
// EXTERNAL MODULE: ./src/context/ExperimentContext.tsx
var ExperimentContext = __webpack_require__(68374);
;// CONCATENATED MODULE: ./src/components/ConditionalRender/experiment-helpers.tsx


function locateChild(tag, children) {
    var child = null;
    react.Children.forEach(children, function(c) {
        if (c.type === tag) {
            child = child || c;
        }
    });
    return child && child.props.children;
}
function childByTagOr(tag, defValue, children) {
    var val = defValue || locateChild(tag, children);
    if (typeof val === "function") {
        return val();
    }
    return val !== null && val !== void 0 ? val : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


;// CONCATENATED MODULE: ./src/components/ConditionalRender/ConditionalRender.tsx






var Experiment = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var Original = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
function ConditionalRender(param) {
    var experimentCode = param.experimentCode, variantValue = param.variantValue, children = param.children, experiment = param.experiment, original = param.original, _triggerExperiment = param.triggerExperiment, triggerExperiment = _triggerExperiment === void 0 ? function() {
        return true;
    } : _triggerExperiment;
    var ref = (0,react.useContext)(ExperimentContext/* default */.Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? "DEFAULT" : tmp;
    var shouldTriggerExperiment = triggerExperiment();
    var logGA4Event = (0,useGA4Analytics/* default */.Z)(experimentCode).logGA4Event;
    (0,react.useEffect)(function() {
        if (shouldTriggerExperiment) {
            esm/* default.fireImpression */.Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        setiTest,
        shouldTriggerExperiment
    ]);
    var callVariant = (setiTest === variantValue || setiTest !== "DEFAULT" && setiTest !== "CONTROL") && shouldTriggerExperiment;
    return callVariant ? childByTagOr(Experiment, experiment, children) : childByTagOr(Original, original, children);
}
ConditionalRender.Experiment = Experiment;
ConditionalRender.Original = Original;


;// CONCATENATED MODULE: ./src/components/ConditionalRender/index.tsx




/***/ }),

/***/ 8176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGA4AnalyticsForSETI; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 22 modules
var browser = __webpack_require__(45741);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/page-map.ts
var pageMap = {
    "/": "homepage",
    "/hotels": "landingpage",
    "/flights": "landingpage",
    "/vacationpackages": "landingpage",
    "/vip": "vip"
};
function mapPage(page) {
    return pageMap[page];
}

;// CONCATENATED MODULE: ./src/constants/product-map.ts
var productMap = {
    "/": "",
    "/hotels": "hotel",
    "/flights": "air",
    "/vacationpackages": "bundle",
    "/vip": "",
    vacations: "bundle",
    hotels: "hotel",
    flights: "air",
    cars: "car",
    cruises: "cruise"
};
function mapProduct(product) {
    return productMap[product];
}

;// CONCATENATED MODULE: ./src/hooks/useRouteInfo.ts



function useRouteInfo() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var pageName = mapPage(pathname);
    var currentTab = (query === null || query === void 0 ? void 0 : query.tab) && !Array.isArray(query.tab) ? query.tab : undefined;
    var productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname);
    return {
        pageName: pageName,
        productName: productName
    };
}

;// CONCATENATED MODULE: ./src/hooks/useGA4Analytics.ts




function isSuccessfulSetiResponse(fullSeti) {
    return fullSeti.length === 0 || fullSeti[0].setiID !== undefined && fullSeti[0].setiVariantID !== undefined;
}
function useGA4AnalyticsForSETI(experimentCode) {
    var fullSETI = (0,react.useContext)(BootstrapDataContext/* default */.Z).fullSETI;
    var routeInfo = useRouteInfo();
    var logGA4Event = (0,react.useCallback)(function() {
        var baseSETI;
        if (isSuccessfulSetiResponse(fullSETI)) baseSETI = fullSETI.find(function(seti) {
            return seti.setiTagName === experimentCode;
        });
        if (!(baseSETI === null || baseSETI === void 0 ? void 0 : baseSETI.setiID)) return;
        browser/* default.GA4Enabled */.Z.GA4Enabled = true;
        browser/* default.logEvent */.Z.logEvent({
            event: "seti",
            attributes: {
                seti_id: baseSETI.setiID,
                seti_variant_id: baseSETI.setiVariantID,
                seti_name: experimentCode,
                page_name: routeInfo.pageName,
                product_name: routeInfo.productName
            }
        });
        browser/* default.GA4Enabled */.Z.GA4Enabled = false;
    }, [
        experimentCode,
        fullSETI,
        routeInfo
    ]);
    return {
        logGA4Event: logGA4Event
    };
}


/***/ }),

/***/ 39939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSeti; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68374);
/* harmony import */ var _useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8176);




function useSeti(experimentCode) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? "DEFAULT" : tmp;
    var logGA4Event = (0,_useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(experimentCode).logGA4Event;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (experimentCode && shouldFireImpression) {
            _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireImpression */ .Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        shouldFireImpression
    ]);
    return setiTest;
}


/***/ }),

/***/ 39997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75271);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14649);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var propTypes = {
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
};
var CloseButton = function (props) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, __assign({}, props, { icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(pcln_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { size: props.size }) }))); };
CloseButton.defaultProps = {
    size: 24,
    title: 'close',
};
CloseButton.propTypes = {};
CloseButton.displayName = 'CloseButton';
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);
//# sourceMappingURL=CloseButton.js.map

/***/ }),

/***/ 32680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6L8 16.6z"
  }));
};

var SvgChevronRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "ChevronRight__SvgChevronRight",
  componentId: "sc-189tolx-0"
})(["outline:none;"]);
SvgChevronRight.isIcon = true;
SvgChevronRight.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ })

}]);